import React, { type FunctionComponent } from 'react'
import { HomeIcon, ListIcon } from '@instacart/ids-core'
import { NavItem } from '../NavItem'

export const ContractorPortalNavMainContent: FunctionComponent = () => (
  <React.Fragment>
    <NavItem
      title="app.contractorPortal.nav.links.home"
      route="app-contractor-portal"
      Icon={HomeIcon}
    />
    {/* TODO(orrin-naylor-instacart): change route to recipes once setup */}
    <NavItem
      title="app.contractorPortal.nav.links.recipes"
      route="app-contractor-portal"
      Icon={ListIcon}
    />
  </React.Fragment>
)
